import {createContext, useContext} from "react";
import { IDateInitial, IListActions, ITablesRelated, TabsActionMODAL } from "../Panel/interface";

interface IPrioritizationMatrixContextProps{
    onLoad: () => void;
	openModalActionAddChange?: (id?: number, onCallback?: Function, tabInitSelected?: TabsActionMODAL | undefined, parentAction?: undefined | number, tablesRelated?: ITablesRelated, subtitle?: string, dateInitial?: IDateInitial, disabled?: boolean) => void;
	openModalActionChangeProgress?: (id: number, subtitle: string, currentPercentage: number, onCallback?: Function, reopen?: boolean, onCallbackClose?: Function, isFinishing?: boolean) => void;
	openModalActionPostponement?: (id: number, titleAction: string, date: Date, onCallback?: Function) => void;
	openModalActionCancel?: (id: number, titleAction: string, onCallback?: Function) => void;
	openModalActionDelete?: (row: IListActions) => void;
}

export const PrioritizationMatrixContext = createContext<IPrioritizationMatrixContextProps>({} as IPrioritizationMatrixContextProps);

export function usePrioritizationMatrix(): IPrioritizationMatrixContextProps{
	const context = useContext(PrioritizationMatrixContext);

	if(!context){
		throw new Error("usePrioritizationMatrix function must be used inside the PrioritizationMatrix Provider.");
	}

	return context;
}
